export default [
    {
        path: '/admin/budgets',
        name: 'indexSubmittingBudgets',
        meta: { title: 'indexSubmittingBudgets' },
        component: () => import('@/pages/admin/budgets'),
    },
]